import * as R from 'ramda'

const DEFAULT_ERROR_MESSAGE =
  'Oops! Something went wrong. Please try again or contact Simplesat support for help.'

export const parseErrorMessage = (message, statusCode, codeDescription) => {
  const jsonObject = _parseJsonDetail(message.detail)
  const errorMessage = extractMessage(jsonObject)

  if (R.isEmpty(errorMessage)) {
    return DEFAULT_ERROR_MESSAGE
  }

  if (statusCode) {
    return `${statusCode}: ${getShortCode(codeDescription)} - ${errorMessage}`
  } else {
    return errorMessage
  }
}

function extractMessage(jsonObject) {
  if (typeof jsonObject === 'object') {
    return R.prop('Message', jsonObject)
  } else if (typeof jsonObject === 'string') {
    return jsonObject
  } else {
    return ''
  }
}

function getShortCode(codeDescription) {
  const mapping = {
    ERR_BAD_OPTION_VALUE: 'Bad Option Value',
    ERR_BAD_OPTION: 'Bad Option',
    ECONNABORTED: 'Connection Aborted',
    ETIMEDOUT: 'Request Timeout',
    ERR_NETWORK: 'Network',
    ERR_FR_TOO_MANY_REDIRECTS: 'Too Many Redirects',
    ERR_DEPRECATED: 'Deprecated',
    ERR_BAD_RESPONSE: 'Bad Response',
    ERR_BAD_REQUEST: 'Bad Request',
    ERR_CANCELED: 'Canceled',
    ERR_NOT_SUPPORT: 'Not Support',
    ERR_INVALID_URL: 'Invalid Url',
  }
  return R.prop(codeDescription, mapping) || ''
}

const _parseJsonDetail = (detail) => {
  try {
    return JSON.parse(detail)
  } catch {
    return ''
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/parseErrorMessage/index.js